export interface EmptyMedia {
    width?: string;
    height?: string;
    type?: MEDIA_TYPE;
    bgColor?: string;
    fontSize?: string;
    color?: string;
    tip?: string;
    iconSize?: string;
    icon?: string;
    iconColor?: string;
}
export enum MEDIA_TYPE {
    IMAGE = "image",
    VIDEO = "video"
}
